var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-queue-complete":_vm.reloadPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }